export function ensureNoUndefinedProperties(
    instance: object,
    keysToBypass: string[] = [],
): void {
    for (const [key, value] of Object.entries(instance)) {
        if (keysToBypass.includes(key)) {
            continue
        }

        if (value === undefined) {
            throw new Error(
                `Property "${key}" cannot be undefined in ${instance.constructor.name}`,
            )
        }
    }
}
